import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react"
import React from "react"
import type { FC } from "react"

interface ModalProps {
  open: boolean
  onClose: () => void
  children: React.ReactNode
  className?: string
}
const Modal: FC<ModalProps> = ({ open, onClose, children, className }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogBackdrop className="fixed inset-0 bg-black/30 z-modalbg" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4 z-modal">
        <DialogPanel
          className={`max-w-lg space-y-4 border bg-white p-5 rounded rounded-lg ${className}`}
        >
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  )
}
export default Modal
